import { render, staticRenderFns } from "./personaledit.vue?vue&type=template&id=15d0b4b3&scoped=true&"
import script from "./personaledit.vue?vue&type=script&lang=js&"
export * from "./personaledit.vue?vue&type=script&lang=js&"
import style0 from "./personaledit.vue?vue&type=style&index=0&id=15d0b4b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0b4b3",
  null
  
)

export default component.exports